import { useTranslation } from "react-i18next";
import styles from "./ManageDevicesHeader.module.css";

export type DeviceTab =
  | "All Devices"
  | "Cameras"
  | "Thermostats";

export const DEVICE_TABS: readonly DeviceTab[] = [
  "All Devices",
  "Cameras",
  "Thermostats",
] as const;

// Translation keys for each tab label.
const TAB_LABEL_KEYS: Record<DeviceTab, string> = {
  "All Devices": "manageDevices.tabs.allDevices",
  Cameras: "manageDevices.tabs.cameras",
  Thermostats: "manageDevices.tabs.thermostats",
};

export interface ManageDevicesHeaderProps {
  activeTab: DeviceTab;
  onTabChange: (tab: DeviceTab) => void;
  // Hide the Cameras / Thermostats tabs when the account has no such devices.
  hasCameras?: boolean;
  hasThermostats?: boolean;
}

export const ManageDevicesHeader = ({
  activeTab,
  onTabChange,
  hasCameras = true,
  hasThermostats = true,
}: ManageDevicesHeaderProps) => {
  const { t } = useTranslation();

  const tabs = DEVICE_TABS.filter((tab) => {
    if (tab === "Cameras") return hasCameras;
    if (tab === "Thermostats") return hasThermostats;
    return true;
  });

  return (
    <div className={styles.headerWrapper}>
      <div
        className={styles.tabs}
        role="tablist"
        aria-label={t("manageDevices.ariaLabels.deviceCategories")}
      >
        {tabs.map((tab) => {
          const isActive = tab === activeTab;
          return (
            <button
              key={tab}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`${styles.tab} ${isActive ? styles.activeTab : ""}`}
              onClick={() => onTabChange(tab)}
            >
              {t(TAB_LABEL_KEYS[tab])}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ManageDevicesHeader;
